/**
 * Build owner "view contact" SMS body — must match Infinitio DLT template exactly.
 * Sample: Hi test, a user with contact number 9191919191 has viewed your contact on 360Coordinates for test VEDANTINFO
 *
 * Mirrors backend sms-owner-message.php (frontend-only; do not change message shape without DLT approval).
 */

/** DLT variable slots are typically capped at ~30 chars (error 635 if exceeded). */
export const DLT_SMS_VAR_MAX_OWNER = Number(
  process.env.REACT_APP_INFINITIO_SMS_VAR_MAX_OWNER || 30,
);
export const DLT_SMS_VAR_MAX_PROPERTY = Number(
  process.env.REACT_APP_INFINITIO_SMS_VAR_MAX_PROPERTY || 30,
);

export function sanitizeSmsPlainText(s) {
  return String(s || '')
    .replace(/[\u060C\u066B]/g, ',')
    .replace(/،/g, ',')
    .replace(/[\u2013\u2014]/g, '-')
    .replace(/[^\x20-\x7E]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function truncateSmsVar(s, max) {
  let t = sanitizeSmsPlainText(s);
  if (t.length <= max) {
    return t;
  }
  return t.slice(0, Math.max(1, max - 1)).trimEnd();
}

/** MSISDN for Infinitio `number` param (91 + 10-digit India). */
export function normalizeSmsMsisdn(phone) {
  const digits = String(phone || '').replace(/\D/g, '');
  if (digits.length === 12 && digits.startsWith('91')) {
    return digits;
  }
  if (digits.length === 10) {
    return `91${digits}`;
  }
  if (digits.length === 11 && digits.startsWith('0')) {
    return `91${digits.slice(1)}`;
  }
  return digits;
}

/** Buyer phone as it appears inside the DLT message body (portal sample uses 10 digits). */
export function formatBuyerPhoneForDltBody(phone) {
  const msisdn = normalizeSmsMsisdn(phone);
  if (msisdn.length === 12 && msisdn.startsWith('91')) {
    return msisdn.slice(2);
  }
  if (msisdn.length === 10) {
    return msisdn;
  }
  return msisdn.slice(-10);
}

/**
 * @param {{ ownerName?: string, buyerPhone?: string, propertyTitle?: string, dltSuffix?: string }} params
 */
export function buildOwnerViewSmsMessage(params = {}) {
  const name =
    truncateSmsVar(params.ownerName || 'User', DLT_SMS_VAR_MAX_OWNER) || 'User';
  const buyer = formatBuyerPhoneForDltBody(params.buyerPhone || '');
  const title =
    truncateSmsVar(params.propertyTitle || 'Property', DLT_SMS_VAR_MAX_PROPERTY) ||
    'Property';

  const suffix = sanitizeSmsPlainText(
    params.dltSuffix !== undefined
      ? params.dltSuffix
      : process.env.REACT_APP_INFINITIO_SMS_DLT_SUFFIX || 'VEDANTINFO',
  ).trim();

  let message;
  if (suffix) {
    message = `Hi ${name}, a user with contact number ${buyer} has viewed your contact on 360Coordinates for ${title} ${suffix}`;
  } else {
    message = `Hi ${name}, a user with contact number ${buyer} has viewed your contact on 360Coordinates for ${title}`;
  }

  return message.slice(0, 480);
}
